class ModelProduct extends HTMLElement {
  constructor() {
    super();
    this.COOKIE_NAME = 'preferred_model_view';
    this.state = this.loadPreferredState() || 'product'; // Default to product view
  }

  connectedCallback() {
    // Set initial toggle state before adding event listeners
    this.updateToggle();
    this.updateProductCards();
    this.setupEventListeners();

    document.getElementById('collection-products').setAttribute('loaded', 'true');
  }

  setupEventListeners() {
    this.addEventListener('click', () => {
      this.state = this.state === 'model' ? 'product' : 'model';
      this.updateToggle();
      this.updateProductCards();
      this.savePreference();

      window.dispatchEvent(new CustomEvent('model-view-changed', { detail: { state: this.state } }));
    });
  }

  updateToggle() {
    this.classList.toggle('active', this.state === 'model');
  }

  updateProductCards() {
    const productCards = document.querySelectorAll('product-card');
    productCards.forEach((card) => {
      card.setAttribute('data-mode', this.state);
    });
  }

  loadPreferredState() {
    return this.getCookie(this.COOKIE_NAME);
  }

  savePreference() {
    // Save for 30 days
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 30);
    document.cookie = `${this.COOKIE_NAME}=${this.state};expires=${expiryDate.toUTCString()};path=/`;
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
}

customElements.define('model-product', ModelProduct);
